export default __webpack_public_path__ + "static/media/beautiful-african-woman.39c96ac2.png";